import { render, staticRenderFns } from "./CaBindingDialog.vue?vue&type=template&id=3b6f8876&"
import script from "./CaBindingDialog.vue?vue&type=script&lang=js&"
export * from "./CaBindingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports